// Module
var code = "<div class=\"mishion_history\"> <div class=\"mission_title\">{{to.headerText}}</div> </div>";
// Exports
var _module_exports = code;;
var path = 'ui-formly/types/header/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;